module.exports = __webpack_public_path__ + "img/colour-palette-button.ed8745b4.svg";